// @ngInject
function OrderArticlesApiService($q, DS, ResourcesService) {

    return {
        getById: getById
    };

    function getById(id) {
        var deferred = $q.defer();

        DS.find('orderarticle', id, { bypassCache: true }).then(function(response) {
            deferred.resolve(response);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function handleError(error) {
        return ResourcesService.handleResourceError(error);
    }
}

angular
    .module('orderarticles.api', [])
    .factory('OrderArticlesApiService', OrderArticlesApiService);
